import React, { Fragment, useEffect, useState } from "react";
//import moment from 'moment'
//import 'moment/locale/zh-cn';
import Scheduler, {
  SchedulerData,
  ViewTypes,
  DATE_FORMAT,
  DemoData,
} from "react-big-scheduler";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import withDragDropContext from "./withDnDContext";
import "react-big-scheduler/lib/css/style.css";
import {getAuthorization} from "../../../../axios/AxiosAut";
import { TiGroup } from "react-icons/ti";
import { useDispatch, useSelector } from "react-redux";
import {
  setAPIDetails,
  setAPIDetailsGroupEvents,
} from "../../../../redux/slices/statistics/statisticSlice";
import { useNavigate } from "react-router-dom";

import { Dialog, Transition } from "@headlessui/react";
import BasicCopy from "./BasicUser";
function Basic() {
  const [status, setStatus] = useState(1); // 0: no show, 1: show yes, 2: show no.
  const Navigate = useNavigate();

  const radioHandler = (status) => {
    setStatus(status);
  };

  const [open, setOpen] = useState(false);
  const [dateState, setDateState] = useState();
  const [showModal, setShowModal] = useState(false);
  const [DropDownValue, setDropDownValue] = useState("group");
  const [ScheduleDetails, setScheduleDetails] = useState();
  const [ResourceBool, setResourceBool] = useState(false);
  const [EventsBool, setEventsBool] = useState(false);
  const [Resources, setResources] = useState();
  const [Events, setEvents] = useState();
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  let schedulerData = new SchedulerData(
    date,
    ViewTypes.Day, // Change the status of daily, weekly or monthly
    false,
    false, // Switch Resources and task name area
    {
      // minuteStep: 15
    }
  );
  const [viewModel, setviewModel] = useState(schedulerData);

  const changeDate = (e) => {
    setDateState(e);
  };

  const APIDetails = useSelector((state) => state.statistics.APIDetails);
  const APIDetailsGroupEvents = useSelector(
    (state) => state.statistics.APIDetailsGroupEvents
  );

  const dispatch = useDispatch();

  const getResources = () => {
    getAuthorization()
      .get(`company/get_companyschedule_recources?assigned_to=${DropDownValue}`)
      .then((res) => {
        if(res.data.message){
          setResources([]);
          dispatch(setAPIDetails([]));
        }else{
          setResources(res.data);
          dispatch(setAPIDetails(res.data));
        }
        setResourceBool(true);
        console.log("dropdown value resource", DropDownValue);
      })
      .catch((err) => {
        console.log("Error in getting schedule", err);
      });
  };

  const getEvents = () => {
    getAuthorization()
      .get(`company/get_companyschedule_events?assigned_to=${DropDownValue}`)
      .then((res) => {
        if(res.data.message){
          setEvents([]);
          dispatch(setAPIDetailsGroupEvents([]));
        }else{
          setEvents(res.data);
          dispatch(setAPIDetailsGroupEvents(res.data));  
        }
        setEventsBool(true);
        console.log("dropdown value events", DropDownValue);
      })
      .catch((err) => {
        console.log("Error in getting schedule", err);
      });
  };

  useEffect(() => {
    // if (APIDetails === null) {
    getResources();
    // }
    // if (APIDetailsGroupEvents === null) {
    getEvents();
    // }
  }, [DropDownValue]);

  //Set Scheduler Data
  useEffect(() => {
    if (ResourceBool) {
      schedulerData.setResources(Resources);
      setviewModel(schedulerData);
    }

    if (EventsBool) {
      schedulerData.setEvents(Events);
      setviewModel(schedulerData);
    }
  }, [ResourceBool, EventsBool, DropDownValue]);

  const prevClick = (schedulerData) => {
    schedulerData.prev();
    schedulerData.setEvents(Events);
    setviewModel(schedulerData);
    Navigate("/dashboard/management/scheduler-dashboard");
  };

  const nextClick = (schedulerData) => {
    schedulerData.next();
    schedulerData.setEvents(Events);
    setviewModel(schedulerData);
    Navigate("/dashboard/management/scheduler-dashboard");
  };

  const onViewChange = (schedulerData, view) => {
    schedulerData.setViewType(
      view.viewType,
      view.showAgenda,
      view.isEventPerspective
    );
    schedulerData.setEvents(Events);
    setviewModel(schedulerData);
  };

  const onSelectDate = (schedulerData, date) => {
    schedulerData.setDate(date);
    schedulerData.setEvents(Events);
    setviewModel(schedulerData);
  };

  const eventClicked = (schedulerData, event) => {
    setOpen(true);
    getAuthorization()
      .get(`company/schedule_detail/${event.id}/`)
      .then((res) => {
        setScheduleDetails(res.data);
        setDateState([
          new Date(`${res.data.start_date}`),
          new Date(`${res.data.end_date}`),
        ]);
      })
      .catch((err) => {
        console.log("Error in getting schedule details", err);
      });
  };

  const ops1 = (schedulerData, event) => {
    setOpen(true);
    getAuthorization()
      .get(`company/schedule_detail/${event.id}/`)
      .then((res) => {
        setScheduleDetails(res.data);
      })
      .catch((err) => {
        console.log("Error in getting schedule details", err);
      });
    // alert(
    //   `You just executed ops1 to event: {id: ${event.id}, title: ${
    //     event.title
    //   }}`
    // );
  };

  const DropDownHandler = (e) => {
    setDropDownValue(e.target.value);
    console.log("target value", e.target.value);
  };

  return (
    <div>
      {console.log("schedulerData", viewModel)}
      <div className="mt-10 w-fit bg-white shadow-lg border-cyan-100 m-auto border-1 rounded-lg pt-4 pb-4">
        <div className="flex flex-row mx-4">
          <p className="text-xl font-bold">Timeline</p>{" "}
          <span>
            <div className="flex flex-row ml-5">
              {/*  <svg
                className="mt-1.5 m-1"
                width="16"
                height="16"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11.875 4.37563C11.875 6.79125 9.91625 8.75063 7.5 8.75063C5.08375 8.75063 3.125 6.79125 3.125 4.37563C3.125 1.95875 5.08375 0 7.5 0C9.91625 0 11.875 1.95875 11.875 4.37563ZM10.8763 8.86312C9.935 9.57375 8.7675 10.0006 7.5 10.0006C6.23125 10.0006 5.06313 9.5725 4.12063 8.86187C1.57562 9.9825 0 13.4719 0 15H15C15 13.4856 13.375 9.99625 10.8763 8.86312Z"
                  fill="#1F78B4"
                />
              </svg>
              <select
                onChange={(e) => DropDownHandler(e)}
                className="flex flex-row justify-center border border-solid border-blue-100 font-Montserrat rounded-lg text-gray-50  font-bold p-1"
              >
                <option
                  className="font-Montserrat text-gray-50 font-bold"
                  value="group"
                >
                  Users
                </option>
                <option
                  className="font-Montserrat text-gray-50 font-bold"
                  value="staff"
                >
                  Groups
                </option>
              </select>*/}
              <div className="inline-flex float-left ml-5">
                <div className="form-check form-check-inline">
                  <input
                    className=" form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="option1"
                    checked={status === 1}
                    onClick={(e) => radioHandler(1)}
                  />
                  <svg
                    className="mt-0.5 m-1 inline-flex"
                    width="16"
                    height="16"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.875 4.37563C11.875 6.79125 9.91625 8.75063 7.5 8.75063C5.08375 8.75063 3.125 6.79125 3.125 4.37563C3.125 1.95875 5.08375 0 7.5 0C9.91625 0 11.875 1.95875 11.875 4.37563ZM10.8763 8.86312C9.935 9.57375 8.7675 10.0006 7.5 10.0006C6.23125 10.0006 5.06313 9.5725 4.12063 8.86187C1.57562 9.9825 0 13.4719 0 15H15C15 13.4856 13.375 9.99625 10.8763 8.86312Z"
                      fill="#1F78B4"
                    />
                  </svg>
                  <label
                    className="form-check-label inline-block ml-1 mr-4 text-gray-800"
                    // for="inlineRadio10"
                  >
                    User
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className=" form-check-input ml-10 appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value="option2"
                    checked={status === 2}
                    onClick={(e) => radioHandler(2)}
                  />
                  <TiGroup
                    className="mt-0 inline-flex"
                    size={25}
                    color="#1F78B4"
                  />

                  <label
                    className="form-check-label inline-block text-gray-800 ml-1
            mr-4"
                    // for="inlineRadio20"
                  >
                    Group
                  </label>
                </div>
              </div>
              {/* <select
                id="userdata"
                onChange={(e) => DropDownHandler(e)}
                className="flex flex-row justify-center border border-solid border-blue-100 font-Montserrat rounded-lg text-gray-50  font-bold p-1"
              >
                <option
                  className="font-Montserrat text-gray-50 font-bold"
                  
                  value=""
                >
                  Users/Groups
                </option>

                <option
                  className="font-Montserrat text-gray-50 font-bold"
                  value="group"
                >
                  Users
                </option>
                <option
                  className="font-Montserrat text-gray-50 font-bold"
                  value="staff"
                >
                  Groups
                </option>
              </select>*/}
            </div>
          </span>
        </div>

        <div className="">
          {status === 1 && (
            <div className="mt-2">
              <BasicCopy />
            </div>
          )}
          {status === 2 && (
            <div className=" mt-2">
              <div className="-mt-4" style={{ marginLeft: "auto" }}>
                <Scheduler
                  // className="w-96"
                  schedulerData={viewModel}
                  prevClick={prevClick}
                  nextClick={nextClick}
                  onSelectDate={onSelectDate}
                  onViewChange={onViewChange}
                  eventItemClick={eventClicked}
                  viewEventClick={ops1}
                  viewEventText="Details"
                />
              </div>
            </div>
          )}
        </div>

        <div
          style={{
            textAlign: "center",
            color: "blue",
            width: "fit-content",
            marginInline: "auto",
            cursor: "pointer",
          }}
        >
          See More
        </div>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={setOpen}
        >
        <div class="flex flex-wrap justify-center mt-8">
          <div className="w-full flex-2 items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-40 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
            <div className="contents">
              <div className="w-2/3 inline-block align-top bg-white rounded-lg text-left overflow-hidden overflow-x-auto shadow-xl transform transition-all sm:my-8 sm:align-middle ">
              <div className="flex">
              <div className="flex-4 flex-row space-x-3">
                
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="container w-auto">
                      
                        <div className="w-full">
                          <Dialog.Title
                            as="h2"
                            className="font-Montserrat text-xl font-bold text-black"
                          >
                            Schedule Details
                          </Dialog.Title>
                          <div className="border-b-2 border-blue-200 w-24"></div>
                        </div>
                      </div>
                    </div>
                    <div className="flex mt-5">
                      <p className="text-gray-700 text-sm font-semibold">
                        {ScheduleDetails?.name}
                      </p>
                    </div>

                    <div
                      className="flex mt-2 flex-row space-x-2
     py-1 uppercase leading-wide text-blue-200 text-sm font-medium"
                    >
                      <div>
                        <svg
                          width="15"
                          height="18"
                          viewBox="0 0 20 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.5259 7.69318H0.47408C0.212388 7.69318 0 7.48079 0 7.2191V4.72117C0 3.44898 1.03492 2.41406 2.30711 2.41406H17.6929C18.9648 2.41406 19.9998 3.44898 19.9998 4.72117V7.21934C20 7.48103 19.7876 7.69318 19.5259 7.69318ZM0.948159 6.74502H19.0518V4.72093C19.0518 3.97165 18.4424 3.36199 17.6931 3.36199H2.30711C1.55759 3.36199 0.948159 3.97165 0.948159 4.72093V6.74502Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M9.55674 22.1988H2.30711C1.03492 22.1988 0 21.1639 0 19.8917V7.21627C0 6.95458 0.212388 6.74219 0.47408 6.74219H19.5259C19.7876 6.74219 20 6.95458 20 7.21627V11.7556C20 12.0173 19.7876 12.2297 19.5259 12.2297C19.2642 12.2297 19.0518 12.0173 19.0518 11.7556V7.69035H0.948159V19.8915C0.948159 20.6408 1.55783 21.2504 2.30711 21.2504H9.55674C9.81843 21.2504 10.0308 21.4628 10.0308 21.7245C10.0308 21.9862 9.81867 22.1988 9.55674 22.1988Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.27877 4.90753C4.01708 4.90753 3.80469 4.69514 3.80469 4.43345V1.34127C3.80469 1.07958 4.01708 0.867188 4.27877 0.867188C4.54046 0.867188 4.75285 1.07958 4.75285 1.34127V4.43345C4.75285 4.69514 4.5407 4.90753 4.27877 4.90753Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M15.7241 4.90753C15.4624 4.90753 15.25 4.69514 15.25 4.43345V1.34127C15.25 1.07958 15.4624 0.867188 15.7241 0.867188C15.9858 0.867188 16.1982 1.07958 16.1982 1.34127V4.43345C16.1982 4.69514 15.9858 4.90753 15.7241 4.90753Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M9.99752 4.90753C9.73583 4.90753 9.52344 4.69514 9.52344 4.43345V1.34127C9.52344 1.07958 9.73583 0.867188 9.99752 0.867188C10.2592 0.867188 10.4716 1.07958 10.4716 1.34127V4.43345C10.4716 4.69514 10.2592 4.90753 9.99752 4.90753Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.26361 10.8195H3.90354C3.74117 10.8195 3.60938 10.6879 3.60938 10.5253V10.1653C3.60938 10.0029 3.74093 9.87109 3.90354 9.87109H4.26361C4.42598 9.87109 4.55777 10.0027 4.55777 10.1653V10.5253C4.55777 10.6879 4.42621 10.8195 4.26361 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M8.20892 10.8195H7.84885C7.68648 10.8195 7.55469 10.6879 7.55469 10.5253V10.1653C7.55469 10.0029 7.68624 9.87109 7.84885 9.87109H8.20892C8.37129 9.87109 8.50309 10.0027 8.50309 10.1653V10.5253C8.50309 10.6879 8.37153 10.8195 8.20892 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M12.1542 10.8195H11.7942C11.6318 10.8195 11.5 10.6879 11.5 10.5253V10.1653C11.5 10.0029 11.6316 9.87109 11.7942 9.87109H12.1542C12.3166 9.87109 12.4484 10.0027 12.4484 10.1653V10.5253C12.4484 10.6879 12.3168 10.8195 12.1542 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M16.0917 10.8195H15.7317C15.5693 10.8195 15.4375 10.6879 15.4375 10.5253V10.1653C15.4375 10.0029 15.5691 9.87109 15.7317 9.87109H16.0917C16.2541 9.87109 16.3859 10.0027 16.3859 10.1653V10.5253C16.3857 10.6879 16.2541 10.8195 16.0917 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.26361 14.7609H3.90354C3.74117 14.7609 3.60938 14.6293 3.60938 14.4667V14.1067C3.60938 13.9443 3.74093 13.8125 3.90354 13.8125H4.26361C4.42598 13.8125 4.55777 13.9441 4.55777 14.1067V14.4667C4.55777 14.6293 4.42621 14.7609 4.26361 14.7609Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M8.20892 14.7609H7.84885C7.68648 14.7609 7.55469 14.6293 7.55469 14.4667V14.1067C7.55469 13.9443 7.68624 13.8125 7.84885 13.8125H8.20892C8.37129 13.8125 8.50309 13.9441 8.50309 14.1067V14.4667C8.50309 14.6293 8.37153 14.7609 8.20892 14.7609Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.26361 18.7062H3.90354C3.74117 18.7062 3.60938 18.5747 3.60938 18.412V18.052C3.60938 17.8896 3.74093 17.7578 3.90354 17.7578H4.26361C4.42598 17.7578 4.55777 17.8894 4.55777 18.052V18.412C4.55777 18.5747 4.42621 18.7062 4.26361 18.7062Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M8.20892 18.7062H7.84885C7.68648 18.7062 7.55469 18.5747 7.55469 18.412V18.052C7.55469 17.8896 7.68624 17.7578 7.84885 17.7578H8.20892C8.37129 17.7578 8.50309 17.8894 8.50309 18.052V18.412C8.50309 18.5747 8.37153 18.7062 8.20892 18.7062Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M15.16 22.203C12.4914 22.203 10.3203 20.0319 10.3203 17.3633C10.3203 14.6945 12.4914 12.5234 15.16 12.5234C17.8286 12.5234 19.9996 14.6945 19.9996 17.3633C19.9996 20.0319 17.8283 22.203 15.16 22.203ZM15.16 13.4716C13.014 13.4716 11.2685 15.2174 11.2685 17.3633C11.2685 19.5092 13.014 21.2548 15.16 21.2548C17.3059 21.2548 19.0514 19.5092 19.0514 17.3633C19.0514 15.2174 17.3056 13.4716 15.16 13.4716Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M14.6677 19.1306C14.6639 19.1306 14.6601 19.1306 14.6563 19.1303C14.5228 19.1272 14.3967 19.0677 14.3093 18.967L13.3033 17.8065C13.1319 17.6088 13.1532 17.3091 13.3511 17.1378C13.5488 16.9666 13.8487 16.9872 14.0198 17.1856L14.6845 17.9525L16.569 15.9789C16.7496 15.789 17.0499 15.7826 17.2391 15.9635C17.4285 16.1443 17.4353 16.4442 17.2545 16.6336L15.0102 18.9841C14.9208 19.0777 14.7971 19.1306 14.6677 19.1306Z"
                            fill="#1F78B4"
                          />
                        </svg>
                      </div>
                      <div className="ml-2">{ScheduleDetails?.start_date}</div>
                      <div>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13437 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                            fill="#1F78B4"
                          />
                        </svg>
                      </div>
                      <div className="ml-2">{ScheduleDetails?.start_time}</div>
                      <div className="pl-4">
                        <svg
                          width="15"
                          height="18"
                          viewBox="0 0 20 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.5259 7.69318H0.47408C0.212388 7.69318 0 7.48079 0 7.2191V4.72117C0 3.44898 1.03492 2.41406 2.30711 2.41406H17.6929C18.9648 2.41406 19.9998 3.44898 19.9998 4.72117V7.21934C20 7.48103 19.7876 7.69318 19.5259 7.69318ZM0.948159 6.74502H19.0518V4.72093C19.0518 3.97165 18.4424 3.36199 17.6931 3.36199H2.30711C1.55759 3.36199 0.948159 3.97165 0.948159 4.72093V6.74502Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M9.55674 22.1988H2.30711C1.03492 22.1988 0 21.1639 0 19.8917V7.21627C0 6.95458 0.212388 6.74219 0.47408 6.74219H19.5259C19.7876 6.74219 20 6.95458 20 7.21627V11.7556C20 12.0173 19.7876 12.2297 19.5259 12.2297C19.2642 12.2297 19.0518 12.0173 19.0518 11.7556V7.69035H0.948159V19.8915C0.948159 20.6408 1.55783 21.2504 2.30711 21.2504H9.55674C9.81843 21.2504 10.0308 21.4628 10.0308 21.7245C10.0308 21.9862 9.81867 22.1988 9.55674 22.1988Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.27877 4.90753C4.01708 4.90753 3.80469 4.69514 3.80469 4.43345V1.34127C3.80469 1.07958 4.01708 0.867188 4.27877 0.867188C4.54046 0.867188 4.75285 1.07958 4.75285 1.34127V4.43345C4.75285 4.69514 4.5407 4.90753 4.27877 4.90753Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M15.7241 4.90753C15.4624 4.90753 15.25 4.69514 15.25 4.43345V1.34127C15.25 1.07958 15.4624 0.867188 15.7241 0.867188C15.9858 0.867188 16.1982 1.07958 16.1982 1.34127V4.43345C16.1982 4.69514 15.9858 4.90753 15.7241 4.90753Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M9.99752 4.90753C9.73583 4.90753 9.52344 4.69514 9.52344 4.43345V1.34127C9.52344 1.07958 9.73583 0.867188 9.99752 0.867188C10.2592 0.867188 10.4716 1.07958 10.4716 1.34127V4.43345C10.4716 4.69514 10.2592 4.90753 9.99752 4.90753Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.26361 10.8195H3.90354C3.74117 10.8195 3.60938 10.6879 3.60938 10.5253V10.1653C3.60938 10.0029 3.74093 9.87109 3.90354 9.87109H4.26361C4.42598 9.87109 4.55777 10.0027 4.55777 10.1653V10.5253C4.55777 10.6879 4.42621 10.8195 4.26361 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M8.20892 10.8195H7.84885C7.68648 10.8195 7.55469 10.6879 7.55469 10.5253V10.1653C7.55469 10.0029 7.68624 9.87109 7.84885 9.87109H8.20892C8.37129 9.87109 8.50309 10.0027 8.50309 10.1653V10.5253C8.50309 10.6879 8.37153 10.8195 8.20892 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M12.1542 10.8195H11.7942C11.6318 10.8195 11.5 10.6879 11.5 10.5253V10.1653C11.5 10.0029 11.6316 9.87109 11.7942 9.87109H12.1542C12.3166 9.87109 12.4484 10.0027 12.4484 10.1653V10.5253C12.4484 10.6879 12.3168 10.8195 12.1542 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M16.0917 10.8195H15.7317C15.5693 10.8195 15.4375 10.6879 15.4375 10.5253V10.1653C15.4375 10.0029 15.5691 9.87109 15.7317 9.87109H16.0917C16.2541 9.87109 16.3859 10.0027 16.3859 10.1653V10.5253C16.3857 10.6879 16.2541 10.8195 16.0917 10.8195Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.26361 14.7609H3.90354C3.74117 14.7609 3.60938 14.6293 3.60938 14.4667V14.1067C3.60938 13.9443 3.74093 13.8125 3.90354 13.8125H4.26361C4.42598 13.8125 4.55777 13.9441 4.55777 14.1067V14.4667C4.55777 14.6293 4.42621 14.7609 4.26361 14.7609Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M8.20892 14.7609H7.84885C7.68648 14.7609 7.55469 14.6293 7.55469 14.4667V14.1067C7.55469 13.9443 7.68624 13.8125 7.84885 13.8125H8.20892C8.37129 13.8125 8.50309 13.9441 8.50309 14.1067V14.4667C8.50309 14.6293 8.37153 14.7609 8.20892 14.7609Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M4.26361 18.7062H3.90354C3.74117 18.7062 3.60938 18.5747 3.60938 18.412V18.052C3.60938 17.8896 3.74093 17.7578 3.90354 17.7578H4.26361C4.42598 17.7578 4.55777 17.8894 4.55777 18.052V18.412C4.55777 18.5747 4.42621 18.7062 4.26361 18.7062Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M8.20892 18.7062H7.84885C7.68648 18.7062 7.55469 18.5747 7.55469 18.412V18.052C7.55469 17.8896 7.68624 17.7578 7.84885 17.7578H8.20892C8.37129 17.7578 8.50309 17.8894 8.50309 18.052V18.412C8.50309 18.5747 8.37153 18.7062 8.20892 18.7062Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M15.16 22.203C12.4914 22.203 10.3203 20.0319 10.3203 17.3633C10.3203 14.6945 12.4914 12.5234 15.16 12.5234C17.8286 12.5234 19.9996 14.6945 19.9996 17.3633C19.9996 20.0319 17.8283 22.203 15.16 22.203ZM15.16 13.4716C13.014 13.4716 11.2685 15.2174 11.2685 17.3633C11.2685 19.5092 13.014 21.2548 15.16 21.2548C17.3059 21.2548 19.0514 19.5092 19.0514 17.3633C19.0514 15.2174 17.3056 13.4716 15.16 13.4716Z"
                            fill="#1F78B4"
                          />
                          <path
                            d="M14.6677 19.1306C14.6639 19.1306 14.6601 19.1306 14.6563 19.1303C14.5228 19.1272 14.3967 19.0677 14.3093 18.967L13.3033 17.8065C13.1319 17.6088 13.1532 17.3091 13.3511 17.1378C13.5488 16.9666 13.8487 16.9872 14.0198 17.1856L14.6845 17.9525L16.569 15.9789C16.7496 15.789 17.0499 15.7826 17.2391 15.9635C17.4285 16.1443 17.4353 16.4442 17.2545 16.6336L15.0102 18.9841C14.9208 19.0777 14.7971 19.1306 14.6677 19.1306Z"
                            fill="#1F78B4"
                          />
                        </svg>
                      </div>
                      <div className="ml-2">{ScheduleDetails?.end_date}</div>
                      <div>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 15 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.5 1.25C10.9462 1.25 13.75 4.05375 13.75 7.5C13.75 10.9462 10.9462 13.75 7.5 13.75C4.05375 13.75 1.25 10.9462 1.25 7.5C1.25 4.05375 4.05375 1.25 7.5 1.25ZM7.5 0C3.35813 0 0 3.35813 0 7.5C0 11.6419 3.35813 15 7.5 15C11.6419 15 15 11.6419 15 7.5C15 3.35813 11.6419 0 7.5 0ZM11.155 7.78687C11.2812 7.81062 11.2813 7.995 11.1556 8.01937C9.96375 8.245 7.3775 8.71375 7.06375 8.71375C6.61437 8.71375 6.25062 8.35 6.25062 7.90062C6.25062 7.58062 6.73187 4.49625 6.95375 3.2475C6.975 3.1275 7.14875 3.13437 7.16813 3.25625L7.78375 7.155L11.155 7.78687Z"
                            fill="#1F78B4"
                          />
                        </svg>
                      </div>
                      <div className="ml-2">{ScheduleDetails?.end_time}</div>
                    </div>
                    <div className="flex flex-row mt-4 mb-4 space-x-1">
                    <svg
                      className="mt-2"
                      width="28"
                      height="2"
                      viewBox="0 0 32 2"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 1H31.5" stroke="#1F78B4" />
                    </svg>
  
                    <p className="font-Montserrat font-medium text-blue-100 text-sm">
                      Customer
                    </p>
                  </div>
                    <div className="flex flex-row space-x-1">
                      <div className=" text-gray-400 py-2 font-medium ">
                        {" "}
                        Customer:
                      </div>
                      <div className="mt-2 mr-8 text-gray-700 font-medium">
                        {ScheduleDetails?.customer.name}
                      </div>
                    </div>
                    <div className="flex flex-row space-x-2 ">
                      <div className=" text-gray-900 py-1 font-medium ">
                        {" "}
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12.5"
                            cy="12.5"
                            r="6.5"
                            stroke="#1F78B4"
                            stroke-width="2"
                          />
                          <path
                            d="M12.5 5V0"
                            stroke="#1F78B4"
                            stroke-width="2"
                          />
                          <path
                            d="M12.5 25V20"
                            stroke="#1F78B4"
                            stroke-width="2"
                          />
                          <path
                            d="M25 12.5L19 12.5"
                            stroke="#1F78B4"
                            stroke-width="2"
                          />
                          <path
                            d="M6 12.5L0 12.5"
                            stroke="#1F78B4"
                            stroke-width="2"
                          />
                          <circle
                            cx="12.5"
                            cy="12.5"
                            r="3"
                            fill="#1F78B4"
                            stroke="#1F78B4"
                          />
                        </svg>
                      </div>
                      <div className="mt-1 sm:ml-4  text-gray-700 font-medium">
                        {ScheduleDetails?.customer.address}
                      </div>
                    </div>
                    <div className="flex flex-row space-x-2 ">
                      <div className=" text-gray-900 py-2 font-medium ">
                        {" "}
                        <svg
                          width="25"
                          height="25"
                          viewBox="0 0 25 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.5 0C5.59687 0 0 5.59687 0 12.5C0 19.4031 5.59687 25 12.5 25C19.4031 25 25 19.4031 25 12.5C25 5.59687 19.4031 0 12.5 0ZM13.5417 16.726V13.5417H16.6604C16.599 14.7323 16.4396 15.875 16.1854 16.9573C15.3281 16.8323 14.4417 16.7615 13.5417 16.726ZM15.5802 18.9781C15.0604 20.3635 14.3729 21.5792 13.5417 22.5781V18.8073C14.2354 18.8365 14.9156 18.8917 15.5802 18.9781ZM13.5417 11.4583V8.31771C14.4458 8.28229 15.3344 8.21042 16.1958 8.08437C16.4438 9.15417 16.601 10.2833 16.6604 11.4583H13.5417ZM13.5417 6.23542V2.42188C14.3812 3.43125 15.074 4.66146 15.5948 6.06354C14.926 6.15104 14.2406 6.20625 13.5417 6.23542ZM16.3573 2.83229C17.6458 3.34896 18.8094 4.11146 19.7844 5.06771C19.1156 5.31146 18.4188 5.52812 17.6812 5.7C17.3229 4.66667 16.874 3.71042 16.3573 2.83229ZM8.81458 16.9573C8.56042 15.875 8.4 14.7323 8.33958 13.5417H11.4583V16.726C10.5573 16.7615 9.67292 16.8323 8.81458 16.9573ZM11.4583 18.8073V22.5781C10.6271 21.5792 9.93958 20.3635 9.41979 18.9781C10.0844 18.8917 10.7646 18.8365 11.4583 18.8073ZM8.33958 11.4583C8.39896 10.2833 8.55521 9.15417 8.80417 8.08437C9.66562 8.21042 10.5542 8.28229 11.4583 8.31771V11.4583H8.33958ZM9.40625 6.06354C9.92708 4.66146 10.6198 3.43125 11.4583 2.42188V6.23542C10.7594 6.20625 10.074 6.15104 9.40625 6.06354ZM7.31771 5.69896C6.58021 5.52708 5.88333 5.31042 5.21562 5.06667C6.19167 4.11042 7.35417 3.34792 8.64271 2.83125C8.12604 3.71042 7.67708 4.66667 7.31771 5.69896ZM6.74583 7.69687C6.47083 8.89583 6.29375 10.1552 6.23333 11.4583H2.13646C2.30833 9.73125 2.90625 8.12812 3.82083 6.75208C4.7375 7.12812 5.7125 7.45 6.74583 7.69687ZM6.75521 17.3448C5.72604 17.5906 4.75521 17.9094 3.84167 18.2823C2.91458 16.899 2.30938 15.2833 2.13646 13.5417H6.23438C6.29479 14.8594 6.475 16.1333 6.75521 17.3448ZM7.33125 19.3417C7.6875 20.3583 8.13125 21.301 8.64062 22.1667C7.36667 21.6562 6.21771 20.9052 5.24896 19.9635C5.91146 19.725 6.60208 19.5104 7.33125 19.3417ZM17.6687 19.3417C18.3979 19.5115 19.0875 19.724 19.751 19.9635C18.7812 20.9042 17.6323 21.6562 16.3583 22.1677C16.8677 21.301 17.3115 20.3583 17.6687 19.3417ZM18.2448 17.3448C18.526 16.1333 18.7052 14.8594 18.7667 13.5417H22.8646C22.6906 15.2833 22.0854 16.899 21.1583 18.2823C20.2448 17.9094 19.2729 17.5906 18.2448 17.3448ZM18.7667 11.4583C18.7062 10.1552 18.5281 8.89583 18.2542 7.69687C19.2875 7.45 20.2635 7.12812 21.1802 6.75208C22.0938 8.12812 22.6917 9.73125 22.8635 11.4583H18.7667Z"
                            fill="#1F78B4"
                          />
                        </svg>
                      </div>
                      <div className="mt-2 sm:ml-4  text-gray-700 font-medium">
                        <a href="https://www.wbsite.com">
                          {" "}
                          {ScheduleDetails?.customer.website}
                        </a>
                      </div>
                    </div>
                    <div className="flex flex-row space-x-2  ">
                      <div className=" text-lime-400 py-2 font-medium ">
                        {" "}
                        Type:
                      </div>
                      <div className="mt-2 mr-8 ml-2 text-gray-700 font-medium">
                        {ScheduleDetails?.type}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-full flex-2 mt-10 sm:w-1/2 md:w-1/3 lg:w-1/5 xl:w-1/6 mb-4 mx-1 rounded-xl mr-6 ">
                <Calendar
                  className="m-auto font-Montserrat shadow-lg  "
                  value={dateState}
                  // onChange={changeDate}
                />
              </div>
             </div>
              <div className="flex flex-row justify-center mb-10 mx-10">
              <button
                type="button"
                className="text-red-600 font-Montserrat font-medium text-lg"
                onClick={() => setOpen(false)}
              >
                Go Back
              </button>
              <button
                type="button"
                class="text-blue-200  font-Montserrat ml-auto bg-transparent font-semibold hover:bg-blue-50   focus:outline-none  rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center  mr-2 mb-2" 
              // onClick={() => Navigate("/dashboard/management/schedule-order/group-user",{
              //   state: ScheduleDetails
              // })}
                >
              <svg
              className="mr-1"

              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
                View Schedule
              </button>
              <button
                type="submit"
                className="text-white float-left bg-green-200 hover:bg-green-100 font-Montserrat font-medium text-lg place-content-center rounded-md pt-2 px-8 flex flex-shrink-1 "
              >
                <svg
                  className="mt-1 mr-1"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.5 18.3332V1.6665L17.5 9.99984L2.5 18.3332Z"
                    fill="white"
                  />
                </svg>
                Join Build
              </button>
            </div>
              </div>
            
            </div>
            </Transition.Child>
           
          </div>
        
        </div>
      
        </Dialog>
      </Transition.Root>
    </div>
  );
}
export default withDragDropContext(Basic);
